export const applicationRouteNames = {
  home: 'home',
  administration: 'administration',
  users: 'users',
  monitoring: 'monitoring',
  subscriptionConfiguration: 'subscription-configuration',
  lokalise: 'lokalise',
};
